<div class="table-responsive">
    @if (costSpecificationFormArray.controls.length > 0) {
        <table class="table m-0" style="table-layout: fixed; min-width: 1500px">
            <thead>
                <tr>
                    <th style="width: 78px"></th>
                    <th style="width: 13%" class="text-center">
                        {{ 'reporting_CONSUMPTION_COST' | translate }}
                    </th>
                    <th style="width: 11%" class="required">
                        {{ 'reporting_EXPENSE' | translate }}
                    </th>
                    <th style="width: 13%" class="required">
                        {{ 'reporting_VAT' | translate }}
                    </th>
                    <th style="width: 20%" class="required">
                        {{ 'reporting_TYPE' | translate }}
                    </th>
                    <th style="width: 15%">
                        {{ 'reporting_CONSUMPTION_AMOUNT' | translate }}
                    </th>
                    <th style="width: 11%">{{ 'reporting_UNIT' | translate }}</th>
                    <th style="width: 16%" class="text-center">
                        {{ 'reporting_CALCULATED_BY_BRUNATA' | translate }}
                    </th>
                    <th style="width: 81px" class="text-end">
                        @if (openForEdit) {
                            <i
                                class="bi bi-info-circle"
                                style="cursor: pointer"
                                popoverClass="custom-popover"
                                ngbPopover="{{ 'reporting_COST_EXPENSE_TOOLTIP' | translate }}"></i>
                        }
                    </th>
                </tr>
            </thead>
            <tbody>
                @for (
                    costSpecification of costSpecificationFormArray.controls;
                    track costSpecification;
                    let striped = $even
                ) {
                    <ng-container [formGroup]="costSpecification">
                        <!-- From webbill -->
                        @if (
                            openForEdit && costSpecification.getRawValue().webBillCostSpecification;
                            as webBillCostSpecification
                        ) {
                            <tr class="webbill-line" [ngClass]="{striped: striped}">
                                <td style="vertical-align: middle">
                                    @if (costSpecification.value.deleted) {
                                        <span class="badge text-bg-danger">
                                            {{ 'reporting_DELETED' | translate }}
                                        </span>
                                    }
                                </td>
                                <td class="text-center">
                                    <app-true-false
                                        [value]="
                                            webBillCostSpecification.consumptionCost
                                        "></app-true-false>
                                </td>
                                <td>
                                    <div class="input-padding">
                                        {{ webBillCostSpecification.lineAmount | appnumber }}
                                    </div>
                                </td>
                                <td>
                                    <div class="input-padding">
                                        {{ vatMap.get(webBillCostSpecification.vat) }}
                                    </div>
                                </td>
                                <td>
                                    <div class="input-padding">
                                        {{ webBillCostSpecification.lineText }}
                                    </div>
                                </td>
                                <td>
                                    <div class="input-padding">
                                        {{ webBillCostSpecification.consumptionAmount | appnumber }}
                                    </div>
                                </td>
                                <td>
                                    <div class="input-padding">
                                        {{ webBillCostSpecification.consumptionUnit }}
                                    </div>
                                </td>
                                <td class="text-center">
                                    <app-true-false
                                        [value]="
                                            webBillCostSpecification.calculatedByBrunata
                                        "></app-true-false>
                                </td>
                                <td class="text-end">
                                    @if (
                                        openForEdit &&
                                        costSpecification.value.deleted &&
                                        costSpecification.value.webBillCostSpecification != null
                                    ) {
                                        <button
                                            type="button"
                                            class="btn btn-text-primary p-0"
                                            (click)="restoreCostLine(costSpecification)">
                                            {{ 'reporting_RESTORE' | translate }}
                                        </button>
                                    }
                                </td>
                            </tr>
                        }
                        <tr [ngClass]="{striped: striped}">
                            <!-- Read only from selfservice -->
                            @if (
                                !openForEdit &&
                                    !costSpecification.value.deleted &&
                                    costSpecification.getRawValue().onlineCostSpecification;
                                as onlineCostSpecification
                            ) {
                                <td></td>
                                <td class="text-center">
                                    <app-true-false
                                        [value]="
                                            onlineCostSpecification.consumptionCost
                                        "></app-true-false>
                                </td>
                                <td>{{ onlineCostSpecification.amount | appnumber: 2 : 2 }}</td>
                                <td>
                                    {{ vatMap.get(onlineCostSpecification.vat ?? '') }}
                                </td>
                                <td>{{ onlineCostSpecification.description }}</td>
                                <td>
                                    {{ onlineCostSpecification.consumptionAmount | appnumber }}
                                </td>
                                <td>
                                    {{ onlineCostSpecification.consumptionUnit }}
                                </td>
                                <td class="text-center">
                                    <app-true-false
                                        [value]="
                                            onlineCostSpecification.calculatedByBrunata
                                        "></app-true-false>
                                </td>
                                <td></td>
                            }
                            <!-- Edit selfservice -->
                            @if (openForEdit && !costSpecification.value.deleted) {
                                <td style="vertical-align: middle">
                                    @if (
                                        costSpecification.value.webBillCostSpecification === null
                                    ) {
                                        <span class="badge text-bg-success">
                                            {{ 'reporting_NEW' | translate }}
                                        </span>
                                    }
                                </td>
                                <td class="text-center">
                                    <span class="form-control-plaintext">
                                        @if (
                                            !creatingMode &&
                                            costSpecification.getRawValue()
                                                .webBillCostSpecification !== null
                                        ) {
                                            <app-true-false
                                                [value]="
                                                    costSpecification.value.consumptionCost ?? false
                                                "></app-true-false>
                                        }
                                        @if (
                                            creatingMode ||
                                            costSpecification.getRawValue()
                                                .webBillCostSpecification === null
                                        ) {
                                            <input
                                                class="form-check-input"
                                                type="checkbox"
                                                formControlName="consumptionCost" />
                                        }
                                    </span>
                                </td>
                                <td>
                                    <app-input-number-group formControlName="amount" />
                                    @if (costSpecification.value.lineAmountDeviationWarning) {
                                        <div class="form-text text-warning-emphasis">
                                            {{
                                                'reporting_COST_AMOUNT_DEVIATES_WARNING' | translate
                                            }}
                                        </div>
                                    }
                                </td>
                                <td>
                                    <app-input-select-option-group
                                        [data]="vatMap"
                                        sortOrder="keys"
                                        formControlName="vat" />
                                </td>
                                <td>
                                    <app-input-typeahead
                                        [data]="lineTextMap"
                                        formControlName="description" />
                                </td>
                                <td>
                                    <app-input-number-group formControlName="consumptionAmount" />
                                    @if (
                                        costSpecification.value.consumptionAmountDeviationWarning
                                    ) {
                                        <div class="form-text text-warning-emphasis">
                                            {{
                                                'reporting_COST_AMOUNT_DEVIATES_PREV_PERIOD_WARNING'
                                                    | translate
                                            }}
                                        </div>
                                    }
                                </td>
                                <td>
                                    <app-input-typeahead
                                        [data]="costUnitMap"
                                        formControlName="consumptionUnit" />
                                </td>
                                <td class="text-center">
                                    <span class="form-control-plaintext">
                                        @if (
                                            costSpecification.getRawValue()
                                                .webBillCostSpecification !== null
                                        ) {
                                            <app-true-false
                                                [value]="
                                                    costSpecification.value.calculatedByBrunata ??
                                                    false
                                                "></app-true-false>
                                        }
                                        @if (
                                            costSpecification.getRawValue()
                                                .webBillCostSpecification === null
                                        ) {
                                            <input
                                                class="form-check-input"
                                                type="checkbox"
                                                formControlName="calculatedByBrunata" />
                                        }
                                    </span>
                                </td>
                                <td class="text-end">
                                    <span class="form-control-plaintext">
                                        @if (
                                            openForEdit && costSpecification.value.deleted === false
                                        ) {
                                            <button
                                                type="button"
                                                class="btn btn-text-danger p-0"
                                                (click)="deleteCostLine(costSpecification)">
                                                <i class="bi bi-trash"></i>
                                            </button>
                                        }
                                    </span>
                                </td>
                            }
                        </tr>
                    </ng-container>
                }
            </tbody>
        </table>
    }
    @if (costSpecificationFormArray.controls.length === 0) {
        <div class="text-warning-emphasis mb-4">
            {{ 'reporting_WARNING_NO_LINES_IN_COST_GROUP' | translate }}
        </div>
    }
</div>
